import React from 'react';

const Jumbo = () => {
  return (
    <div className="jumbo">
      <div className="jumboText">
        <p className="jumboTextMain">
          <span className="blue-bottom">Save</span> Your Tweets Now, <span className="blue-bottom">Access</span> Them For Later.
        </p>
      </div>

      <img id="jumboImg" src={require('../../assets/addtweets.svg')} alt="people cartoon svg" />
    </div>
  );
};

export default Jumbo;